import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-935cb8fe")

_pushScopeId("data-v-935cb8fe")
const _hoisted_1 = { class: "message-header" }
const _hoisted_2 = { class: "has-text-weight-normal" }
const _hoisted_3 = { class: "message-body" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "half-days-msg"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#calendar-comments-teleport-target" }, [
    _createVNode("div", {
      class: ["comment-notification message", { 'comment-notification--visible': _ctx.isActive }]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName) + " ", 1),
          _createVNode("span", _hoisted_2, _toDisplayString(_ctx.actionInfo), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.day.formattedDate), 1)
        ])
      ]),
      _createVNode("div", _hoisted_3, [
        (_ctx.day.comment)
          ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.day.comment), 1))
          : _createCommentVNode("", true),
        (_ctx.day.comment && _ctx.halfDaysMsg)
          ? (_openBlock(), _createBlock("br", _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.halfDaysMsg)
          ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.halfDaysMsg), 1))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
})